import { render, staticRenderFns } from "./EscritorioView.vue?vue&type=template&id=6dea1d28"
import script from "./EscritorioView.vue?vue&type=script&lang=js"
export * from "./EscritorioView.vue?vue&type=script&lang=js"
import style0 from "./EscritorioView.vue?vue&type=style&index=0&id=6dea1d28&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports